import Api from "./../config/api"

interface IAxiosResponse {
    data: any
}

/**
 * /callcenter/admin/carrier-blocks — same middleware and permission stack as the robocall
 * screens.
 *
 * Every settings change carries a comment and the API rejects one without it. That is not
 * ceremony: the existing history rows ("start blocking", "spamAttack!", "Impersonation: on.")
 * are how the timeline of an incident gets reconstructed afterwards, and a switch with no
 * comment breaks that permanently.
 */
export class CarrierBlocksActions {

    static getRules(filters: { tier?: string, active?: string, q?: string } = {},
                    page?: number, perPage?: number): Promise<any> {
        const query: string[] = []
        if (filters.tier) { query.push(`tier=${filters.tier}`) }
        if (filters.active !== undefined && filters.active !== '') {
            query.push(`active=${filters.active}`)
        }
        if (filters.q && filters.q !== '') { query.push(`q=${encodeURIComponent(filters.q)}`) }
        if (page && page > 1) { query.push(`page=${page}`) }
        if (perPage) { query.push(`per_page=${perPage}`) }

        return Api.get("/carrier-blocks" + (query.length ? `?${query.join('&')}` : ''))
            .then((res: IAxiosResponse) => res.data)
    }

    static createRule(payload: {
        carrier_name: string, tier: string, note?: string, line_type?: string,
    }): Promise<any> {
        return Api.post("/carrier-blocks", payload).then((res: IAxiosResponse) => res.data)
    }

    /** carrier_name is deliberately not editable server-side — delete and re-create. */
    static updateRule(id: number, payload: {
        tier?: string, note?: string, active?: boolean, line_type?: string,
    }): Promise<any> {
        return Api.patch("/carrier-blocks/" + id, payload).then((res: IAxiosResponse) => res.data)
    }

    static deleteRule(id: number): Promise<any> {
        return Api.delete("/carrier-blocks/" + id).then((res: IAxiosResponse) => res.data)
    }

    static getSettings(): Promise<any> {
        return Api.get("/carrier-blocks/settings").then((res: IAxiosResponse) => res.data)
    }

    static updateSettings(payload: { [k: string]: any }, comment: string): Promise<any> {
        return Api.put("/carrier-blocks/settings", { ...payload, comment })
            .then((res: IAxiosResponse) => res.data)
    }

    static getStats(days: number = 7): Promise<any> {
        return Api.get(`/carrier-blocks/stats?days=${days}`).then((res: IAxiosResponse) => res.data)
    }

    /** Carriers not yet on any list, ranked by junk rate — the list is maintained from data. */
    static getCandidates(days: number = 7, minReached: number = 40): Promise<any> {
        return Api.get(`/carrier-blocks/candidates?days=${days}&min_reached=${minReached}`)
            .then((res: IAxiosResponse) => res.data)
    }
}
